import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import { displayColorBySituation } from '@/utils/common'
import { Historico, SituacaoEnum } from '@/types/_'
import moment from 'moment'
import modalHistoricoSituacaoModule from './modal-historico-situacao.module'
import FinanceiroStore from '../RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component({
  ...modalHistoricoSituacaoModule,
})
export default class ComponentModalHistoricoCadastroAluguel extends Vue {
  activeTab = 'tab-0'

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  close() {
    this.getShowModalHistoricoGeracaoItens = false
  }

  get history() {
    return this.getHistoricoStore.historicoGeracaoItens
  }

  get getHistoricoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getShowModalHistoricoGeracaoItens() {
    return this.getHistoricoStore.modalHistoricoGeracaoItens.historicoGeracaoItens
  }

  set getShowModalHistoricoGeracaoItens(value: boolean) {
    this.getHistoricoStore.clearHistoricoGeracaoItens()
    this.getHistoricoStore.setShowModalHistoricoGeracaoItens(value)
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  historicoGeracaoItensHeader: any[] = [
    { text: 'Criado por', value: 'createdByNome', align: 'center', sortable: false },
    { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Profissional anterior', value: 'prestadorOld', align: 'center', sortable: false },
    { text: 'Profissional novo', value: 'prestadorNew', align: 'center', sortable: false },
    { text: 'Prestador anterior', value: 'valorOld', align: 'center', sortable: false },
    { text: 'Prestador novo', value: 'valorNew', align: 'center', sortable: false },
    { text: 'Função anterior', value: 'tipoOld', align: 'center', sortable: false },
    { text: 'Função novo', value: 'tipoNew', align: 'center', sortable: false },
  ]

  /**
 * Paginação
 */

  get itemsLength() {
    return Math.ceil(this.getHistoricoStore.totalItems / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsTabelaPontuacaoProfissionalPagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsTabelaPontuacaoProfissionalPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    const id = this.getHistoricoStore.idForLoadItems
    await this.getHistoricoStore.getHistoricoGeracaoItens(id)
    this.loadingDataTable = false
  }
}
